module.exports = __webpack_public_path__ + "static/media/hang-loose.2abcffbb.mov";